import { Pagination, Row, Table, TableProps } from 'antd';

export interface ITableWrapProps<T> {
  columns: TableProps<T>['columns'];
  data?: T[];
  isLoading?: boolean;
  page?: number;
  size?: number;
  total?: number;
  children?: any;
  rowKey?: string;
  className?: string;
  rowSelection?: TableProps<T>['rowSelection'];
  scroll?: TableProps<T>['scroll'];
  setSize?: (size: number) => void;
  setPage?: (page: number) => void;
}

function TableWrap<T extends object>(props: ITableWrapProps<T>) {
  return (
    <>
      <Table
        className={props.className}
        dataSource={props.data}
        columns={props.columns}
        loading={props.isLoading}
        rowSelection={props.rowSelection}
        pagination={false}
        locale={{ emptyText: 'データなし' }}
        rowKey={props.rowKey || 'id'}
        scroll={props.scroll}
      >
        {props.children}
      </Table>
      <Row className="d-flex justify-content-center mt-3">
        <Pagination
          pageSize={props.size}
          current={props.page}
          total={props.total}
          onShowSizeChange={(current, size) => props.setSize && props.setSize(size)}
          onChange={(page) => props.setPage && props.setPage(page)}
          showSizeChanger={false}
        />
      </Row>
    </>
  );
}

export default TableWrap;
